import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from "react";
import { NumericFormat } from "react-number-format";
import { DataGrid } from "@mui/x-data-grid";
import Form from "react-bootstrap/Form";
import ColumnResizer from "react-table-column-resizer";
import DatePicker from "react-datepicker";
import moment from "moment";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { Formik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ModalAllder } from "layouts/ModalAllder";
import Checkbox from "@mui/material/Checkbox";
import { useWindowSize } from "hooks/useWindowSize";
import { Button } from "bootstrap";
import { getDayDiffFromNow } from "utils/HelperFunction";
export function ModalProductReceive(param) {
    var action = param.action, productReceive = param.productReceive, setModalProductReceive = param.setModalProductReceive, modalProductReceive = param.modalProductReceive, setProductRow = param.setProductRow;
    var _useState = _sliced_to_array(useState(""), 2), product = _useState[0], setProduct = _useState[1];
    var _useState1 = _sliced_to_array(useState([
        {
            number: "",
            zoneID: "",
            receiveQty: "",
            dateExpire: ""
        }
    ]), 2), list = _useState1[0], setList = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sum = _useState2[0], setSum = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 340,
        height: 280,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState3[0], setModalSuccess = _useState3[1];
    var schema = yup.object().shape({
        receivelist: yup.array().of(yup.object().shape({
            receiveQty: yup.number().required("Receive quantity is required").min(1, "Receive quantity must be at least 1").test("total-receiveQty", "Total receive quantity cannot exceed ".concat(product.productReceiveQuantity || "the maximum limit"), function() {
                if (product.productReceiveQuantity === 0) {
                    return false;
                }
                return sum <= product.productReceiveQuantity;
            })
        }))
    });
    var _useState4 = _sliced_to_array(useState(false), 2), acceptInvalid = _useState4[0], setAcceptInvalid = _useState4[1];
    var formRef = useRef();
    var handleSubmitFromBtn = function() {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };
    useEffect(function() {
        setProduct(productReceive);
        if (productReceive.receivelist) {
            setList(productReceive.receivelist);
        } else {
            setList([
                {
                    number: "",
                    zoneID: "",
                    receiveQty: "",
                    dateExpire: ""
                }
            ]);
        }
    }, [
        productReceive
    ]);
    useEffect(function() {
        if (!modalProductReceive.open) {
            formRef.current.resetForm();
        }
    }, [
        modalProductReceive
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                htitle: "จัดการข้อมูลสินค้าเพิ่มเติม",
                hbtn: true,
                modal: modalProductReceive,
                setModal: setModalProductReceive,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "  ",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center mb-4",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-[18px] font-bold text-[#545454] mr-auto ",
                                    children: [
                                        "ชื่อสินค้า : ",
                                        product.productName,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    name: "sumproductBalanceQuantity",
                                    className: "form-control text-center disabled:bg-[#EDFFFF] text-[#3FA5FF] text-lg font-bold w-[98px]",
                                    placeholder: "",
                                    value: sum,
                                    disabled: true
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-[18px] text-[#545454] ml-5  font-bold ",
                                    children: [
                                        "จำนวนรับ :",
                                        " ",
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "text-[#FF0000]",
                                            children: [
                                                " ",
                                                product.productReceiveQuantity,
                                                " "
                                            ]
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(Formik, {
                                innerRef: formRef,
                                enableReinitialize: true,
                                initialValues: {
                                    receivelist: list
                                },
                                validationSchema: schema,
                                onSubmit: function(values) {
                                    // const formdataPayload = new FormData();
                                    setProductRow(function(prev) {
                                        return prev.map(function(el) {
                                            if (el.rowID === product.rowID) {
                                                return _object_spread_props(_object_spread({}, el), {
                                                    // productReceiveQuantity: sum,
                                                    receivelist: values.receivelist
                                                });
                                            }
                                            return el;
                                        });
                                    });
                                    setModalProductReceive(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                children: function(param) {
                                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
                                    return /*#__PURE__*/ _jsx(Form, {
                                        noValidate: true,
                                        onSubmit: function(e) {
                                            e.preventDefault();
                                            handleSubmit();
                                        },
                                        children: /*#__PURE__*/ _jsx(FieldArray, {
                                            name: "receivelist",
                                            // onChange={() => alert('xx')}
                                            render: function(arrayHelpers) {
                                                var productreceiveQty = 0;
                                                values.receivelist.forEach(function(pd) {
                                                    var receiveQty = parseFloat(pd.receiveQty);
                                                    var hasValidreceiveQty = receiveQty > 0;
                                                    if (hasValidreceiveQty) {
                                                        productreceiveQty += receiveQty;
                                                    }
                                                });
                                                setSum(productreceiveQty);
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("table", {
                                                            className: "column_resize_table table1 table-striped ",
                                                            style: {
                                                                width: "auto"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx("thead", {
                                                                    children: /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("th", {
                                                                                className: "!bg-[#3FA5FF] text-white font-semibold !py-[15px] !text-base",
                                                                                children: "เลขที่ LOT / BATCH / SERIAL NO."
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                className: "columnResizer !bg-[#3FA5FF] ",
                                                                                minWidth: 5,
                                                                                defaultWidth: 350
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("th", {
                                                                                className: "!bg-[#2DC76D] text-white font-semibold !text-base",
                                                                                children: "โซนจัดเก็บ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                className: "columnResizer !bg-[#2DC76D]",
                                                                                defaultWidth: 190,
                                                                                minWidth: 5
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("th", {
                                                                                className: "!bg-[#FF6B00] text-white font-semibold !text-base",
                                                                                children: "จำนวนที่รับ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                className: "columnResizer !bg-[#FF6B00]",
                                                                                minWidth: 5,
                                                                                defaultWidth: 190
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("th", {
                                                                                className: "!bg-[#909090] text-white font-semibold !text-base",
                                                                                children: "วันหมดอายุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                className: "columnResizer !bg-[#909090]",
                                                                                minWidth: 5,
                                                                                defaultWidth: 190
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("th", {
                                                                                className: "!bg-[#F95057] text-white font-semibold !text-base",
                                                                                children: "ลบที่เลือก"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                className: "columnResizer !bg-[#F95057]",
                                                                                minWidth: 5,
                                                                                defaultWidth: 100
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("tbody", {
                                                                    children: values.receivelist && values.receivelist.map(function(receive, index) {
                                                                        return /*#__PURE__*/ _jsxs("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("th", {
                                                                                    className: " !text-[#545454] font-semibold !px-0 !text-base",
                                                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "receivelist[".concat(index, "].number"),
                                                                                        value: values.receivelist[index].number,
                                                                                        onChange: handleChange,
                                                                                        className: "form-control border-0 rounded-0 text-left disabled:bg-[#EDFFFF] text-[#545454] text-lg font-bold w-full",
                                                                                        placeholder: ""
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                    className: "columnResizer  ",
                                                                                    minWidth: 5,
                                                                                    defaultWidth: 250
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("th", {
                                                                                    className: "!text-[#545454] !px-0 font-semibold !text-base",
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: "-"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                    className: "columnResizer ",
                                                                                    defaultWidth: 160,
                                                                                    minWidth: 5
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("th", {
                                                                                    className: " !text-[#545454] !px-0 font-semibold !text-base",
                                                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "number",
                                                                                        name: "receivelist[".concat(index, "].receiveQty"),
                                                                                        onChange: function(e) {
                                                                                            setFieldValue("receivelist[".concat(index, "].receiveQty"), e.target.value);
                                                                                        },
                                                                                        value: values.receivelist[index].receiveQty,
                                                                                        className: "form-control border-[#FFF] rounded-0 text-center disabled:bg-[#EDFFFF] text-[#545454] text-lg font-bold w-full",
                                                                                        placeholder: "",
                                                                                        isInvalid: errors.receivelist && errors.receivelist[index] && !!errors.receivelist[index].receiveQty
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                    className: "columnResizer ",
                                                                                    minWidth: 5,
                                                                                    defaultWidth: 160
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("th", {
                                                                                    className: "!text-[#545454] !px-0 font-semibold !text-base",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                                            inputFormat: "DD/MM/YYYY",
                                                                                            dateFormat: "dd/MM/yyyy",
                                                                                            selected: values.receivelist[index].dateExpire ? moment(values.receivelist[index].dateExpire).toDate() : "",
                                                                                            onChange: function(date) {
                                                                                                // Validate the date before setting it
                                                                                                if (moment(date).isValid()) {
                                                                                                    // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                                                    setFieldValue("receivelist[".concat(index, "].dateExpire"), moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                                                } else {
                                                                                                    setFieldValue("receivelist[".concat(index, "].dateExpire"), "");
                                                                                                }
                                                                                            },
                                                                                            placeholder: "DD/MM/YYYY",
                                                                                            placeholderText: values.receivelist[index].dateExpire ? "DD/MM/YYYY" : "ไม่ระบุ",
                                                                                            className: "w-100 datepicker2 form-control pl-4 border-0"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "text-[#FF0000] font-bold fs-12 text-center",
                                                                                            children: [
                                                                                                "คงเหลือ",
                                                                                                " ",
                                                                                                getDayDiffFromNow(values.receivelist[index].dateExpire),
                                                                                                " ",
                                                                                                "วัน"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                    className: "columnResizer ",
                                                                                    minWidth: 5,
                                                                                    defaultWidth: 160
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("th", {
                                                                                    className: "!text-[#545454] !px-0 font-semibold !text-base",
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "flex justify-center",
                                                                                        children: values.receivelist.length > 1 && action === "create" && /*#__PURE__*/ _jsx("button", {
                                                                                            onClick: function() {
                                                                                                arrayHelpers.remove(index);
                                                                                            },
                                                                                            className: "rounded-full bg-[#F95057]  aspect-square w-[30px] flex justify-center items-center",
                                                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                                                className: "object-contain aspect-square w-[18px]",
                                                                                                src: "/images/icon-trash.png",
                                                                                                alt: ""
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                                    className: "columnResizer ",
                                                                                    minWidth: 5,
                                                                                    defaultWidth: 10
                                                                                })
                                                                            ]
                                                                        }, index);
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        action === "create" && /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex items-center mt-5",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("button", {
                                                                    type: "button",
                                                                    className: "btn btn-st-3 mr-auto text-[16px]",
                                                                    onClick: function() {
                                                                        return arrayHelpers.push({
                                                                            number: "",
                                                                            zoneID: "",
                                                                            receiveQty: "",
                                                                            dateExpire: ""
                                                                        });
                                                                    },
                                                                    children: "เพิ่มแถว"
                                                                }),
                                                                /*#__PURE__*/ _jsx("button", {
                                                                    type: "button",
                                                                    className: "btn btn-st-6 me-3 text-[16px]",
                                                                    onClick: function() {
                                                                        return setModalProductReceive(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                open: false
                                                                            });
                                                                        });
                                                                    },
                                                                    children: "ยกเลิก"
                                                                }),
                                                                /*#__PURE__*/ _jsx("button", {
                                                                    type: "submit",
                                                                    className: "btn btn-st-3 me-3 text-[16px]",
                                                                    children: "บันทึก"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    });
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกใบรับสินค้าสำเร็จ"
                    })
                ]
            })
        ]
    });
}
